import styled from 'styled-components';

export const TermsWrapperElement = styled.div`
    display: block;
    margin: 12px auto 0;
    font-size: 0.75em;
    line-height: 1;
    text-align: left;
    color: inherit;
`;
